import { useContext } from "react";
import LocaleContext from "../app/locale/LocaleContext.js";
export default function () {
    return useContext(LocaleContext);
}
